import React from "react"
import { Control, UseFormRegister } from "react-hook-form"
import {
  InputCreateOrUpdateBundleGroup,
  Maybe,
  ValidDateRange
} from "lib/types/generated/graphql-types"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import Input from "../../../Ui/Form/Input"
import TimePeriodSelectionBundles from "../TimePeriodSelectionBundles"
import { WithAuth } from "../../../Auth"
import { PermissionGroups } from "../../../../routes/constants"
import FallbackInput from "../../../Ui/Form/FallbackInput"

type Props = {
  register: UseFormRegister<InputCreateOrUpdateBundleGroup>
  errors: FieldErrors<InputCreateOrUpdateBundleGroup>
  control: Control<InputCreateOrUpdateBundleGroup>
  defaultName?: string
  defaultTimeRange?: Maybe<ValidDateRange> | undefined
}

const GeneralSettings = ({ register, errors, control, defaultName, defaultTimeRange }: Props) => {
  return (
    <div>
      <h2>General settings</h2>
      <WithAuth
        requiredGroups={PermissionGroups.discounts.write}
        fallback={<FallbackInput label={"Bundle group name"} value={defaultName} />}
      >
        <Input
          register={register}
          name={"name"}
          errors={errors}
          label={"Bundle group name"}
          defaultValue={defaultName ?? ""}
        />
      </WithAuth>
      <WithAuth
        requiredGroups={PermissionGroups.discounts.write}
        fallback={
          defaultTimeRange?.from &&
          defaultTimeRange?.to && (
            <FallbackInput label={"Time period limitation"} dateTime={defaultTimeRange} />
          )
        }
      >
        <TimePeriodSelectionBundles
          control={control}
          errors={errors}
          description={"Limit bundle group to only be valid between selected dates"}
          defaultValues={defaultTimeRange}
        />
      </WithAuth>
    </div>
  )
}

export default GeneralSettings
